"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTranslations = exports.defaultSettings = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _faImage = require("@fortawesome/pro-regular-svg-icons/faImage");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var defaultTranslations = {
  pluginName: 'Image',
  pluginDescription: 'Insert an image.'
};
exports.defaultTranslations = defaultTranslations;
var defaultSettings = {
  Controls: function Controls() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Controls for this plugin were not provided");
  },
  Renderer: function Renderer() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Renderer for this plugin was not provided");
  },
  translations: defaultTranslations,
  IconComponent: /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faImage.faImage,
    size: "3x"
  })
};
exports.defaultSettings = defaultSettings;